// NEW_FILE_JUSTIFIED: Accordion wrapper for benefit sections — composes BenefitItemCard within Shadcn Accordion per .pen design
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
} from '@/components/ui/accordion';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { BenefitItemCard } from './BenefitItemCard';
import type { IBenefitSectionAccordionProps } from '@/@types/coverage';

export function BenefitSectionAccordion({
  sections,
  utilizationByItemId,
  currency,
  planCoinsurance,
}: IBenefitSectionAccordionProps) {
  if (sections.length === 0) {
    return (
      <div className="rounded-xl border border-border bg-card py-10 text-center">
        <p className="text-sm text-muted-foreground">No coverage sections defined.</p>
      </div>
    );
  }

  return (
    <Accordion type="multiple" defaultValue={[]}>
      <div className="flex flex-col gap-4">
        {sections.map(section => (
          <AccordionItem
            key={section._id}
            value={section._id}
            className="rounded-xl border border-border bg-muted overflow-hidden"
          >
            <AccordionPrimitive.Header className="flex">
              <AccordionPrimitive.Trigger
                className={cn(
                  'flex flex-1 items-center justify-between px-5 py-4 text-left outline-none',
                  '[&[data-state=open]>svg]:rotate-180'
                )}
              >
                <span className="text-[15px] font-semibold text-foreground">{section.name}</span>
                <span className="ml-auto mr-3 text-sm text-foreground-muted font-normal">
                  {section.items.length} item{section.items.length !== 1 ? 's' : ''}
                </span>
                <ChevronDown aria-hidden="true" className="size-5 shrink-0 text-foreground-muted transition-transform duration-200" />
              </AccordionPrimitive.Trigger>
            </AccordionPrimitive.Header>
            <AccordionContent className="pb-0">
              <div className="flex flex-col gap-3 pt-1">
                {section.items.map(item => (
                  <div key={item._id}>
                    <BenefitItemCard
                      item={item}
                      utilization={utilizationByItemId.get(item._id)}
                      currency={currency}
                      planCoinsurance={planCoinsurance}
                    />
                  </div>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </div>
    </Accordion>
  );
}
